import { FC, ReactNode } from 'react';
import { IconButton } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';
import styled from '@emotion/styled';

interface Props {
  children: ReactNode;
  onDismiss: () => void;
}

const Bar = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.5rem',
  width: '100%',
  padding: '0.5rem 0.75rem',
  background: '#fff8e1',
  borderLeft: `3px solid ${theme.palette.warning.main}`,
  borderRadius: '0 8px 8px 0',
  fontSize: '0.82rem',
  color: theme.palette.text.primary,
  whiteSpace: 'pre-line',
}));

const IconWrap = styled.div({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  color: '#f9a825',
  paddingTop: '1px',
});

const Text = styled.span({
  flex: 1,
  lineHeight: 1.4,
});

export const AnalyticsNotice: FC<Props> = ({ children, onDismiss }) => (
  <Bar>
    <IconWrap>
      <WarningAmberRoundedIcon fontSize="small" />
    </IconWrap>
    <Text>{children}</Text>
    <IconButton size="small" onClick={onDismiss} sx={{ flexShrink: 0, padding: '2px' }}>
      <CloseIcon sx={{ fontSize: '0.9rem' }} />
    </IconButton>
  </Bar>
);
